
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util';
    import ListBase from '@/lib/listbase';
    import PageRequest from '@/store/entities/page-request';
    import ReportView from '@/components/helper/report-view.vue';


    @Component({
        components: { ReportView },
    })
    export default class InfosReport extends ListBase {
        @Prop({ type: PageRequest, default: () => { return new PageRequest() } }) pagerequest: PageRequest;
        entity: string = 'workshopinfo';

        columns = [
            this.gCol('document', 'DNI', 'text', null, false),
            this.gCol('employee_name', 'Nombre y Apellido', 'text', null, false),
            this.gCol('email', 'Email', 'text', null, false),
            this.gCol('phone', 'Telefono', 'text', null, false),
            this.gCol('nro', 'Nro de Cuentas', 'text', null, false)
        ]

        get list() {
            return this.$store.state.workshopinfo.reportList;
        };
        get loading() {
            return this.$store.state.workshopinfo.loading;
        };
        get pageSize() {
            return this.$store.state.workshopinfo.pageSize;
        };

        /************* BOTONES DE ACCION ***************/
        async getpage() {
            await this.$store.dispatch({
                type: 'workshopinfo/reportInfo',
                data: this.pagerequest
            });
        }

        mounted() {
            this.getpage();
        }
    }
